import Modal from "../modal/new";

import styles from "./ConfirmDialog.module.css";

const ConfirmDialog = ({

    open,

    title = "تأیید عملیات",

    message = "آیا مطمئن هستید؟",

    confirmText = "تأیید",

    cancelText = "انصراف",

    loading = false,

    onConfirm,

    onCancel,

}) => {

    return (

        <Modal

            open={open}

            title={title}

            size="sm"

            closeOnBackdrop={!loading}

            onClose={onCancel}

        >

            <div className={styles.container}>

                <p className={styles.message}>

                    {message}

                </p>

                <div className={styles.actions}>

                    <button

                        type="button"

                        className={styles.cancel}

                        disabled={loading}

                        onClick={onCancel}

                    >

                        {cancelText}

                    </button>

                    <button

                        type="button"

                        className={styles.confirm}

                        disabled={loading}

                        onClick={onConfirm}

                    >

                        {

                            loading

                                ?

                                "در حال انجام..."

                                :

                                confirmText

                        }

                    </button>

                </div>

            </div>

        </Modal>

    );

};

export default ConfirmDialog;